import type { CartItemType } from '@/store/types/cart'
import { sendGTMEvent } from '@next/third-parties/google'
import type { GtmGlobalStoreProps } from '../../useGTM'
import { getEcommerceObjectForAddToCart } from '../../helpers/getEccomerceObjectForAddToCart'
import { gtmClearEcommerceData } from '../../helpers/clearEcommerceData'

export type AddToCartEventLocationsType =
  | 'product_page_main_button'
  | 'product_page_frequenlty_bougth'
  | 'cart_you_may_also_like'
  | 'cart_increase_item_quantity'

export type GtmAddToCartProps = {
  cartItem: CartItemType
  event_location: AddToCartEventLocationsType
}

export const gtmAddToCart = ({
  globalStore,
  cartItem,
  event_location,
}: GtmAddToCartProps & GtmGlobalStoreProps) => {
  if (!cartItem) return

  const uuid = crypto.randomUUID()

  gtmClearEcommerceData()

  sendGTMEvent({
    event: 'add_to_cart',
    event_id: uuid,
    ecommerce: getEcommerceObjectForAddToCart({
      globalStore,
      cart: [cartItem],
      event_location,
    }),
  })
}
